import React, { useEffect } from 'react'
import { toast } from 'sonner'
import { X } from 'lucide-react'
import { AnnouncementToaster } from '../../../components/ui/sonner'
import { Button } from '../../../components/Button/Button'

type AnnouncementBannerData = {
  announcement: string
  bannerColor: string
  linkto?: string
}[]

export const AnnouncementBanner = ({
  data,
}: {
  data: AnnouncementBannerData
}) => {
  useEffect(() => {
    console.log('AnnouncementBanner data:', data) // Debug log

    if (!data || data.length === 0) {
      console.log('No announcements to display')
      return
    }

    // Check if there is a provenanceAnnouncements item in local storage
    let closedAnnouncements = ['']
    const currentLocalStorage = localStorage.getItem('provenanceAnnouncements')
    if (!currentLocalStorage) {
      localStorage.setItem('provenanceAnnouncements', '')
    } else {
      closedAnnouncements = JSON.parse(currentLocalStorage)
    }

    // Show announcements that haven't been closed
    data.forEach(item => {
      if (!closedAnnouncements.find(closed => item.announcement === closed)) {
        console.log('Showing announcement:', item.announcement) // Debug log
        const toastId = toast(item.announcement, {
          onDismiss: () => {
            closedAnnouncements.push(item.announcement)
            localStorage.setItem(
              'provenanceAnnouncements',
              JSON.stringify(closedAnnouncements),
            )
          },
          id: item.announcement, // Use announcement as unique ID
          unstyled: true,
          // Use description for the Learn More button
          description: item.linkto && (
            <Button
              btnType="light"
              size="small"
              linkTo={item.linkto}
              className="mt-3 w-full rounded-lg"
            >
              Learn More
            </Button>
          ),
          // Use cancel button for the close functionality
          cancel: {
            label: <X className="h-4 w-4" />,
            onClick: () => {
              // Save to localStorage before dismissing the toast
              closedAnnouncements.push(item.announcement)
              localStorage.setItem(
                'provenanceAnnouncements',
                JSON.stringify(closedAnnouncements),
              )
              // Explicitly dismiss the toast
              toast.dismiss(item.announcement)
            },
          },
        })
      }
    })
  }, [data])

  return <AnnouncementToaster />
}
